module.exports = __webpack_public_path__ + "img/SEGURIFY_landing_icono_fondo_ADT.b10a8f05.gif";